import React, { useState} from 'react';
import { useTranslation } from "react-i18next";
import { Button } from 'primereact/button';
import BlagajnaUnos from './BlagajnaTabs/BlagajnaUnos';
import BlagajnaAkontacijaUnos from './BlagajnaTabs/BlagajnaAkontacijaUnos';
import BlagajnaPregled from './BlagajnaTabs/BlagajnaPregled';
import PregledTroskovaZaPeriod from './BlagajnaTabs/PregledTroskovaZaPeriod';
import PregledAkontacijaZaPeriod from './BlagajnaTabs/PregledAkontacijaZaPeriod';

const Blagajna = () =>{
  const { t } = useTranslation();

      const [changeView, setChangeView] = useState(1);
      const activeClass = 'activeButton'
    
return (
    <div className="Blagajna" style={{marginTop:"1%"}}>
        <Button id={changeView == 1 && activeClass} label={t('finansije.pregledSalda')} className="mt-3 zaposleniShift" style={{fontSize: 'smaller'}} onClick={()=> {setChangeView(1)} } />
        <Button id={changeView == 3 && activeClass} label={t('finansije.unosSalda')} className="mt-3 zaposleniShift" style={{fontSize: 'smaller'}}  onClick={()=> {setChangeView(3)} } />
        <Button id={changeView == 2 && activeClass} label={t('finansije.unosAkontacije')} className="mt-3 zaposleniShift" style={{fontSize: 'smaller'}}  onClick={()=> {setChangeView(2)} } />
        <Button id={changeView == 4 && activeClass} label={t('finansije.pregledTroskova')} className="mt-3 zaposleniShift" style={{fontSize: 'smaller'}}  onClick={()=> {setChangeView(4)} } />
        <Button id={changeView == 5 && activeClass} label={t('finansije.pregledAkontacija')} className="mt-3 zaposleniShift" style={{fontSize: 'smaller'}}  onClick={()=> {setChangeView(5)} } />

        {changeView == 1 &&  <BlagajnaPregled/>}
        {changeView == 2 &&  <BlagajnaAkontacijaUnos/>}
        {changeView == 3 && <BlagajnaUnos/>}
        {changeView == 4 && <PregledTroskovaZaPeriod/>}
        {changeView == 5 && <PregledAkontacijaZaPeriod/>}
    </div>
  );
};

export default Blagajna;